import { Accordion, AccordionDetails, AccordionSummary, Box, Button, FormControl, Grid, Input, InputAdornment, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate, useOutletContext } from 'react-router-dom';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { format } from 'date-fns';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import { CustomDescrypt } from '../../../../../../utils/MyEncryption';
// import { AuthStore } from '../../../../../../store/UserStore';
// import { base_url } from '../../../../../../utils/GlobalVariables';
import Swal from 'sweetalert2';
import axios from 'axios';
import { CustomDescrypt } from '../../../../../utils/MyEncryption';
import { AuthStore } from '../../../../../store/UserStore';
import { base_url } from '../../../../../utils/GlobalVariables';

const FormModal = ({ pencairan }) => {
    const { setBreadcrumbItem } = useOutletContext();
    const navigate = useNavigate();
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const [loading, setLoading] = useState(false);
    const logOut = AuthStore((state) => state.logOut);
    const [listKontrak, setListKontrak] = useState([])
    const [formData, setFormData] = useState({
        // _method: null,
        tgl_spm: "",
        no_spm: "",
        no_spp: "",
        jenis: "LS",
        jenis_ls: "Modal",
        keperluan: "",
        anggaran: "",
        file_spm: "",
        file_dokumentasi: "",
        file_berita_acara: "",
        file_progres: "",
        revisi: null,
        kontrak: ""
        // progres: ""
    });
    const [srcSpm, setSrcSpm] = useState("");
    const [srcDokumentasi, setSrcDokumentasi] = useState("");
    const [srcProgress, setSrcProgress] = useState("");
    const [srcBA, setSrcBA] = useState("");

    useEffect(() => {
        setBreadcrumbItem({ '/bnd': 'Home', '/bnd/pencairan': 'SPM', '': pencairan === null ? 'Tambah (LS Modal)' : 'Edit (LS Modal)' });
        console.log(pencairan);
        requestKontrak();

        if (pencairan !== null) {
            setFormData({
                _method: 'PUT',
                tgl_spm: pencairan.tgl_spm,
                no_spm: pencairan.no_spm,
                no_spp: pencairan.no_spp,
                jenis: pencairan.jenis,
                jenis_ls: pencairan.jenis_ls,
                keperluan: pencairan.keperluan,
                anggaran: rP(pencairan.anggaran),
                file_spm: "",
                file_dokumentasi: "",
                file_berita_acara: "",
                file_progres: "",
                revisi: pencairan.revisi,
                progres: pencairan.progres,
                kontrak: pencairan.kontrak
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        pencairan === null ?
            formData.file_spm === "" ?
                setSrcSpm("")
                :
                setSrcSpm(URL.createObjectURL(formData.file_spm))
            :
            formData.file_spm === "" ?
                setSrcSpm(base_url + '/uploads/' + decryptedUser.tahun_anggaran + '/' + decryptedUser.id_opd + '/ls/spm/' + pencairan.file)
                :
                setSrcSpm(URL.createObjectURL(formData.file_spm))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData.file_spm])

    useEffect(() => {
        pencairan === null ?
            formData.file_dokumentasi === "" ?
                setSrcDokumentasi("")
                :
                setSrcDokumentasi(URL.createObjectURL(formData.file_dokumentasi))
            :
            formData.file_dokumentasi === "" ?
                setSrcDokumentasi(base_url + '/uploads/' + decryptedUser.tahun_anggaran + '/' + decryptedUser.id_opd + '/ls/dokumentasi/' + pencairan.file)
                :
                setSrcDokumentasi(URL.createObjectURL(formData.file_dokumentasi))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData.file_dokumentasi])

    useEffect(() => {
        pencairan === null ?
            formData.file_progres === "" ?
                setSrcProgress("")
                :
                setSrcProgress(URL.createObjectURL(formData.file_progres))
            :
            formData.file_progres === "" ?
                setSrcProgress(base_url + '/uploads/' + decryptedUser.tahun_anggaran + '/' + decryptedUser.id_opd + '/ls/progres/' + pencairan.file)
                :
                setSrcProgress(URL.createObjectURL(formData.file_progres))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData.file_progres])

    useEffect(() => {
        pencairan === null ?
            formData.file_berita_acara === "" ?
                setSrcBA("")
                :
                setSrcBA(URL.createObjectURL(formData.file_berita_acara))
            :
            formData.file_berita_acara === "" ?
                setSrcBA(base_url + '/uploads/' + decryptedUser.tahun_anggaran + '/' + decryptedUser.id_opd + '/ls/berita_acara/' + pencairan.file)
                :
                setSrcBA(URL.createObjectURL(formData.file_berita_acara))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData.file_berita_acara])

    const requestKontrak = () => {
        // setTableLoading(true)
        axios.get(
            base_url + '/bnd/kontrak',
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`
                }
            })
            .then((response) => {
                console.log(response);
                const data = response.data;
                setListKontrak(data)
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.status + ' ' + error.response.statusText
                    })
                }
                // setTableLoading(false)
            })
    }

    const onChangeInput = (e) => {
        if (e.target.name === "anggaran") {
            formatRupiah(e);
        }
        else {
            setFormData({
                ...formData,
                [e.target.name]: e.target.value
            })
        }
        // console.log(formData);
    }

    const formatRupiah = (e) => {
        const nominal = e.target.value;
        const nominalz = nominal.replace(/\./g, '')
        const price = new Intl.NumberFormat('id-ID').format(nominalz);
        setFormData({
            ...formData,
            [e.target.name]: price
        })
    }

    const rP = (e) => {
        const cur = new Intl.NumberFormat("id-ID", {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0
        }).format(e);
        return cur;
    }

    const loadData = event => {
        const file = event.target.files[0];
        console.log(file);
        console.log(event);
        if (file === undefined || file === "") {
            setFormData({
                ...formData,
                [event.target.name]: ""
            })
        }
        else {
            setFormData({
                ...formData,
                [event.target.name]: file
            })
        }
        console.log(formData);
    }

    const submitForm = () => {
        const isValid = checkForm(formData);
        if (!isValid) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Isi semua Input'
            })
            return;
        }

        setLoading(true);
        axios.post(
            base_url + '/bnd/pencairan/insert_ls_modal',
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`,
                    'content-type': 'multipart/form-data'
                }
            })
            .then((response) => {
                setLoading(false);

                Swal.fire({
                    icon: 'success',
                    title: 'Berhasil',
                    text: response.data.msg
                })

                navigate("/bnd/pencairan", { replace: true });
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.status + ' ' + error.response.statusText
                    })
                }
                setLoading(false)
            })
    }

    const updateData = () => {
        console.log(formData);
        setLoading(true);
        axios.post(
            base_url + '/bnd/pencairan/update_ls_modal',
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`,
                    'content-type': 'multipart/form-data'
                }
            })
            .then((response) => {
                setLoading(false);

                Swal.fire({
                    icon: 'success',
                    title: 'Berhasil',
                    text: response.data.msg
                })

                navigate("/bnd/pencairan", { replace: true });
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.status + ' ' + error.response.statusText
                    })
                }
                setLoading(false)
            })
    }

    function checkForm(obj) {
        for (var key in obj) {
            if (obj[key] === "") {
                if (key !== "kontrak") {
                //     console.log("Check Form Salah ");
                // }
                // else {
                    console.log("Check Form Salah " + [key]);
                    return false;
                }
            }
        }
        // if (obj.kontrak === "") {
        //     console.log('kontrak null');
        //     for (let key in obj) {
        //         if (obj[key] === "") {
        //             if (key === "kontrak" || key === "file_dokumentasi" || key === "file_berita_acara" || key === "file_progres") {
        //                 console.log("Check Form Benar " + [key]);
        //             }
        //             else{
        //                 console.log("Check Form Salah " + [key]);
        //                 return false;
        //             }
        //         }
        //     }
        // }
        // else {
        //     console.log('kontrak ada');
        //     for (let key in obj) {
        //         if (obj[key] === "") {
        //             console.log("Check Form Salah " + [key]);
        //             return false;
        //         }
        //     }
        // }
        // console.log(obj.kontrak);
        // console.log("Check Form Benar");
        return true;
    }

    return (
        <Box sx={{ flexGrow: 1 }}>
            {formData.revisi === null ? "" :
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography color={"error"}>Note : {formData.revisi}</Typography>
                    </Grid>
                </Grid>
            }
            <Grid container spacing={4}>
                <Grid item xs={12} md={3}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                            disableFuture
                            label="Tanggal SPM"
                            openTo="day"
                            inputFormat="yyyy-MM-dd"
                            value={formData.tgl_spm}
                            onChange={(newValue) => {
                                setFormData({
                                    ...formData,
                                    tgl_spm: format(new Date(newValue), "yyyy-MM-dd")
                                })
                                console.log(formData);
                            }}
                            renderInput={(params) => <TextField {...params} fullWidth variant="standard" sx={{ mt: 2 }} />}
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={12} md={3} sx={{ textAlign: "center" }}>
                    <TextField
                        fullWidth
                        name='no_spm'
                        id="standard-basic"
                        label="Nomor SPM"
                        variant="standard"
                        margin="normal"
                        value={formData.no_spm}
                        onChange={(e) => onChangeInput(e)}
                        error={formData.no_spm === "" ? true : false}
                        inputProps={{
                            readOnly: (pencairan !== null)
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={3} sx={{ textAlign: "center" }}>
                    <TextField
                        fullWidth
                        name='no_spp'
                        id="standard-basic"
                        label="Nomor SPP"
                        variant="standard"
                        margin="normal"
                        value={formData.no_spp}
                        onChange={(e) => onChangeInput(e)}
                        error={formData.no_spp === "" ? true : false}
                    />
                </Grid>
                <Grid item xs={12} md={3} sx={{ textAlign: "center" }}>
                    <FormControl fullWidth sx={{ my: 2 }} variant="standard">
                        <InputLabel htmlFor="standard-adornment-amount">Nilai Kotor</InputLabel>
                        <Input
                            id="standard-adornment-amount"
                            value={formData.anggaran || ''}
                            onChange={onChangeInput}
                            startAdornment={<InputAdornment position="start">Rp</InputAdornment>}
                            name="anggaran"
                            onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                }
                            }}
                            error={formData.anggaran === "" || formData.anggaran === "0" ? true : false}
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        multiline
                        fullWidth
                        name='keperluan'
                        id="standard-basic"
                        label="Keperluan"
                        variant="standard"
                        margin="normal"
                        rows={4}
                        value={formData.keperluan}
                        onChange={(e) => onChangeInput(e)}
                        error={formData.keperluan === "" ? true : false}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={2} py={2} justifyContent="center">
                <Grid item xs={12} sm={6} lg={4}>
                    <FormControl variant="standard" fullWidth sx={{ m: 1 }} >
                        <InputLabel id="demo-simple-select-standard-label">Kontrak</InputLabel>
                        <Select
                            labelId="demo-simple-select-standard-label"
                            name='kontrak'
                            id="demo-simple-select-standard"
                            onChange={(e) => onChangeInput(e)}
                            label="Age"
                            value={formData.kontrak}
                            defaultChecked={formData.kontrak}
                        >
                            {
                                listKontrak.map((item) => (
                                    <MenuItem key={item.no_kontrak} value={item.no_kontrak}>{item.no_kontrak}<br />Rp. {rP(item.jumlah_kontrak)},-</MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
            <Grid container spacing={2} py={2} justifyContent="center">
                <Grid item xs={"auto"}>
                    <Button
                        variant="outlined"
                        component="label"
                        startIcon={<AttachFileIcon />}
                        color={
                            pencairan === null ?
                                formData.file_spm === "" ? "error" : "primary"
                                :
                                "primary"
                        }
                    >
                        File SPM dll
                        <input
                            hidden
                            name='file_spm'
                            accept="application/pdf"
                            multiple type="file"
                            onChange={loadData}
                        />
                    </Button>
                </Grid>
            </Grid>
            {srcSpm === "" ?
                "" :
                <Grid container spacing={2} py={2} justifyContent="center">
                    <Grid item xs={10} sx={{ textAlign: "center" }}>
                        <Accordion>
                            <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMoreIcon />}>
                                <Typography>File</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <iframe width='100%' height={700} title="Pdf" src={srcSpm} />
                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                </Grid>
            }
            <Grid container spacing={2} py={2} justifyContent="center">
                <Grid item xs={"auto"}>
                    <Button
                        variant="outlined"
                        component="label"
                        startIcon={<AttachFileIcon />}
                        color={
                            pencairan === null ?
                                formData.file_dokumentasi === "" ? "error" : "primary"
                                :
                                "primary"
                        }
                    >
                        File Dokumentasi
                        <input
                            hidden
                            name='file_dokumentasi'
                            accept="application/pdf"
                            multiple type="file"
                            onChange={loadData}
                        />
                    </Button>
                </Grid>
            </Grid>
            {srcDokumentasi === "" ?
                "" :
                <Grid container spacing={2} py={2} justifyContent="center">
                    <Grid item xs={10} sx={{ textAlign: "center" }}>
                        <Accordion>
                            <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMoreIcon />}>
                                <Typography>File</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <iframe width='100%' height={700} title="Pdf" src={srcDokumentasi} />
                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                </Grid>
            }
            <Grid container spacing={2} py={2} justifyContent="center">
                <Grid item xs={"auto"}>
                    <Button
                        variant="outlined"
                        component="label"
                        startIcon={<AttachFileIcon />}
                        color={
                            pencairan === null ?
                                formData.file_progres === "" ? "error" : "primary"
                                :
                                "primary"
                        }
                    >
                        File Progres
                        <input
                            hidden
                            name='file_progres'
                            accept="application/pdf"
                            multiple type="file"
                            onChange={loadData}
                        />
                    </Button>
                </Grid>
            </Grid>
            {srcProgress === "" ?
                "" :
                <Grid container spacing={2} py={2} justifyContent="center">
                    <Grid item xs={10} sx={{ textAlign: "center" }}>
                        <Accordion>
                            <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMoreIcon />}>
                                <Typography>File</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <iframe width='100%' height={700} title="Pdf" src={srcProgress} />
                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                </Grid>
            }
            <Grid container spacing={2} py={2} justifyContent="center">
                <Grid item xs={"auto"}>
                    <Button
                        variant="outlined"
                        component="label"
                        startIcon={<AttachFileIcon />}
                        color={
                            pencairan === null ?
                                formData.file_berita_acara === "" ? "error" : "primary"
                                :
                                "primary"
                        }
                    >
                        File Berita Acara
                        <input
                            hidden
                            name='file_berita_acara'
                            accept="application/pdf"
                            multiple type="file"
                            onChange={loadData}
                        />
                    </Button>
                </Grid>
            </Grid>
            {srcBA === "" ?
                "" :
                <Grid container spacing={2} py={2} justifyContent="center">
                    <Grid item xs={10} sx={{ textAlign: "center" }}>
                        <Accordion>
                            <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMoreIcon />}>
                                <Typography>File</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <iframe width='100%' height={700} title="Pdf" src={srcBA} />
                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                </Grid>
            }
            <Grid container spacing={2} py={2} justifyContent="flex-end">
                <Grid item >
                    <LoadingButton
                        onClick={pencairan === null ? submitForm : updateData}
                        loading={loading}
                        variant="contained"
                        margin="normal"
                        loadingPosition="start"
                        startIcon={<SaveIcon />}
                    >
                        {pencairan === null ? "Simpan" : "Update"}
                    </LoadingButton>
                </Grid>
            </Grid>
        </Box>
    )
}

export default FormModal